import React from 'react';
import { useNotifications } from '../../hooks';

interface NotificationBadgeProps {
  children: React.ReactNode;
  className?: string;
  maxCount?: number;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  children,
  className = '',
  maxCount = 99,
}) => {
  const { unreadCount } = useNotifications();

  // Don't render badge if no unread notifications
  if (!unreadCount || unreadCount <= 0) {
    return <>{children}</>;
  }

  // Format count display (e.g., 99+ for large numbers)
  const displayCount = unreadCount > maxCount ? `${maxCount}+` : unreadCount.toString();

  // Determine badge size and position based on count
  const badgeSize = unreadCount < 10 ? 'w-5 h-5' : 'min-w-5 h-5 px-1';

  return (
    <div className={`relative inline-flex ${className}`}>
      {children}
      <div className={`absolute -top-1 -right-1 ${badgeSize} rounded-full bg-red-500 flex items-center justify-center z-10`}>
        <span className="text-xs text-white font-medium">{displayCount}</span>
      </div>
    </div>
  );
};

export default NotificationBadge;